<template>
  <div>
    <Loading v-show="loading" />
  </div>
</template>

<script>
import Loading from '@/ui/shared/Loading.vue'
import { authService } from '@/modules/auth/services/auth.service'
import { buildMenuItens } from '@/modules/auth/utils/menu-loader'
import { mapMutations } from 'vuex'

export default {
  name: 'LoginTempView',
  components: { Loading },
  data() {
    return {
      loading: true,
    }
  },
  mounted() {
    this.siginTemp()
  },
  methods: {
    ...mapMutations('user', ['addUserLogged', 'addItemMenu', 'removeItemMenu']),
    async siginTemp() {
      try {
        const response = await authService.loginTemp({
          codeLoginTemp: this.$route.params.code,
          companyId: this.$route.params.companyId,
        })
        const content = response.data.content
        await this.$store.dispatch('auth/setAuthData', content)
        this.addUserLogged(content)
        this.loadMenu(content)
        this.$router.replace(this.$route.query.redirect || '/dashboard')
      } catch (e) {
        // erros já são exibidos pelo Messages; para o loading para não travar a tela
        this.loading = false
      }
    },
    loadMenu(content) {
      this.removeItemMenu()
      this.addItemMenu(buildMenuItens(content.user.rules))
    },
  },
}
</script>
